import {
  Box,
  makeStyles,
  InputLabel,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  Button,
  Typography,
  MenuItem,
  Select,
  Chip,
} from "@material-ui/core";

import React, { useEffect, useState, Fragment } from "react";
import { Helmet } from "react-helmet";
import { backend } from "../../api";
import { PageBanner } from "../../components";
import { DropzoneArea } from "material-ui-dropzone";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { authorAddBook } from "../../redux-store/books/actions";
import { ADD_BOOK_RESET } from "../../redux-store/constants";
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles((theme) => ({
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
  selectedCategoryChip: {
    margin: theme.spacing(0.5),
  },
  categoryChipContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  storyText: {
    whiteSpace: 'pre-line',
  },
}));

const AddBook = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.auth);
  const { success } = useSelector((state) => state.addBook);

  const [title, setTitle] = useState("");
  const [cover, setCover] = useState("");
  const [story, setStory] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [pdfFile, setPdfFile] = useState("");
  const [checked, setChecked] = useState({
    "E-Book": true,
    hardcover: false,
    paperback: false,
  });
  const [bookTypes, setBookTypes] = useState("e-book");
  const [hardcoverPrice, setHardCoverPrice] = useState(0);
  const [digitalPrice, setDigitalPrice] = useState(0);
  const [paperbackPrice, setPaperbackPrice] = useState(0);
  const [deliveryPrice, setDeliveryPrice] = useState({
    next_day_delivery: 0,
    three_days_delivery: 0,
    standard_delivery: 0,
  });
  const [categories, setCategories] = useState([]);
  const [isCoverUploaded, setIsCoverUploaded] = useState(false);
  const [isPdfUploaded, setIsPdfUploaded] = useState(false);
  const [addToKlever, setAddToKlever] = useState(false);
  let formData = new FormData();

  useEffect(() => {
    fetchCategory();
    if (location.state?.addToKlever) {
      setAddToKlever(true);
    }
    if (success) {
      dispatch({ type: ADD_BOOK_RESET });
      history.replace(`/dashboard/${currentUser?.author?.role}`);
    }
    if (checked.hardcover && checked.paperback) {
      setBookTypes("all");
    } else if (!checked.hardcover && checked.paperback) {
      setBookTypes("paperback");
    } else if (checked.hardcover && !checked.paperback) {
      setBookTypes("hardcover");
    } else {
      setBookTypes("e-book");
    }
  }, [success, checked, location.state]);

  const fetchCategory = () => {
    backend
      .get(`/category?isActive=${true}`)
      .then((res) => {
        if (res.data.message === "Book Category Found Successfully") {
          setCategories(res.data.data);
        }
      })
      .catch((err) => {
        const message = err.response ? err.response.data.message : err.message;
        toast.error(message);
      });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!isCoverUploaded || !isPdfUploaded) {
      toast.error("Please upload the required files.");
      return;
    }

    const newBook = {
      book_title: title,
      book_category: selectedCategories,
      book_story: story,
      book_cover: cover,
      author: currentUser.author._id,
      writer: currentUser._id,
      pdf_file: pdfFile,
      print_on_demand: "author",
      price: {
        hardcover_price: hardcoverPrice,
        digital_price: digitalPrice,
        paperback_price: paperbackPrice,
      },
      delivery: {
        next_day_delivery: deliveryPrice.next_day_delivery,
        three_days_delivery: deliveryPrice.three_days_delivery,
        standard_delivery: deliveryPrice.standard_delivery,
      },
      addToKlever: addToKlever,
      bookTypes,
    };

    if (checked["E-Book"]) {
      dispatch(authorAddBook(newBook));
    }

    if (addToKlever) {
      try {
        const kleverBook = {
          book_title: title,
          book_category: selectedCategories.map((cat) => cat._id),
          writer: currentUser._id,
          book_story: story,
          pdf_file: pdfFile,
          book_cover: cover,
          addToKlever: true,
          price: {
            hardcover_price: hardcoverPrice,
            digital_price: digitalPrice,
            paperback_price: paperbackPrice,
          },
        };
        await backend.post("/adverbook", kleverBook);
        toast.success("Book added to Klever successfully");
      } catch (error) {
        toast.error("Error adding book to Klever");
      }
    }
  };

  const handleCategoryChange = (event) => {
    const category = event.target.value;
    if (!selectedCategories.includes(category)) {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  const handleRemoveCategory = (categoryToRemove) => {
    setSelectedCategories(selectedCategories.filter(category => category !== categoryToRemove));
  };

  const uploadFileToS3 = (role, file) => {
    formData = new FormData();
    formData.append("files", file);
    backend
      .post("/file/fileUpload", formData)
      .then((res) => {
        console.log("res".res)
        if (res.status === 200) {
          const fileLocation = res.data.locationArray[0].fileLocation;
          if (role === "cover") {
            setCover(fileLocation);
            setIsCoverUploaded(true);
          } else if (role === "pdfBook") {
            setPdfFile(fileLocation);
            setIsPdfUploaded(true);
          }
        }
      })
      .catch((err) => {
        toast.error({ "Error in File Upload": err });
      });
  };

  const handleAddToKleverCheckbox = (e) => {
    setAddToKlever(e.target.checked);
  };

  const selectBookTypes = (e) => {
    setChecked({ ...checked, [e.target.name]: e.target.checked });
  };

  return (
    <Fragment>
      <Helmet>
        <title>Add E-Book</title>
      </Helmet>
      <ToastContainer />
      <PageBanner
        image={"/assets/images/bg4.jpg"}
        title={"Add E-Book"}
        size="small"
        titleAlign="left"
      />
      <Box style={{ width: "80%", maxWidth: 600, margin: "50px auto" }}>
        <Typography variant="body2" color="error" style={{ marginBottom: 20 }}>
          * All Field are Necessary
        </Typography>
        {categories && (
          <form onSubmit={handleFormSubmit}>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Title</InputLabel>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="text"
                  required
                  className={classes.inputField}
                  name="title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </FormControl>
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Book Types</InputLabel>
              <FormControl variant="outlined" fullWidth>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked["E-Book"]}
                      value="E-Book"
                      name="E-Book"
                      color="primary"
                      onChange={(e) => setChecked({ ...checked, [e.target.name]: e.target.checked })}
                      disabled
                    />
                  }
                  label="E-Book"
                />
              </FormControl>
              <FormControl variant="outlined" fullWidth>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={addToKlever}
                      value={"Add To Klever"}
                      name="AddToKlever"
                      color="primary"
                      onChange={handleAddToKleverCheckbox}
                    />
                  }
                  label="Add To Kleverbook"
                />
              </FormControl>
            </Box>

            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Cover</InputLabel>
              <DropzoneArea
                onChange={(files) => uploadFileToS3("cover", files[0])}
                acceptedFiles={["image/*"]}
                filesLimit={1}
                onDelete={() => setCover("")}
                name="img"
                id="cvr"
                inputProps={{
                  name: "img",
                  id: "cvr",
                  required: true,
                  style: { display: "inline-block", opacity: 0 },
                }}
                dropzoneText="Upload Image for Book Cover"
                style={{ maxHeight: 100 }}
              />
            </Box>
            <Box mb={5} mt={5}>
              <InputLabel className={classes.fieldLabel}>Categories</InputLabel>
              <FormControl fullWidth variant="outlined">
                <Select
                  value=""
                  onChange={handleCategoryChange}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select Category</MenuItem>
                  {categories.map((category) => (
                    <MenuItem key={category._id} value={category}>
                      {category.category_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box mt={2} className={classes.categoryChipContainer}>
                {selectedCategories.map((category) => (
                  <Chip
                    key={category._id}
                    label={category.category_name}
                    onDelete={() => handleRemoveCategory(category)}
                    className={classes.selectedCategoryChip}
                    deleteIcon={<CancelIcon />}
                  />
                ))}
              </Box>
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>
                BOOK INTERIOR PDF File
              </InputLabel>
              <DropzoneArea
                onChange={(files) => uploadFileToS3("pdfBook", files[0])}
                acceptedFiles={["application/pdf"]}
                filesLimit={1}
                name="book"
                id="bookfile"
                inputProps={{
                  name: "book",
                  id: "bookfile",
                  required: true,
                  style: { display: "inline-block", opacity: 0 },
                }}
                onDelete={() => setPdfFile("")}
                dropzoneText="Upload PDF File of Book"
                style={{ maxHeight: 100 }}
              />
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Story</InputLabel>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="text"
                  required
                  className={classes.inputField}
                  multiline
                  rows={8}
                  name="story"
                  value={story}
                  onChange={(e) => setStory(e.target.value)}
                  InputProps={{
                    className: classes.storyText,
                  }}
                />
              </FormControl>
            </Box>

            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>
                Digital Price
              </InputLabel>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="number"
                  required
                  name="digital_price"
                  className={classes.inputField}
                  onChange={(e) => setDigitalPrice(+e.target.value)}
                />
              </FormControl>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button
                className={classes.cancelBtn}
                onClick={() => history.goBack()}
              >
                Go Back
              </Button>
              <Button type="submit" className={classes.submitBtn}>
                Add
              </Button>
            </Box>
          </form>
        )}
      </Box>
    </Fragment>
  );
};

export default AddBook;
